/**
 * 해지/재개 ConfirmManager 본문.
 * useSubscriptionActions(.ts)는 JSX를 못 쓰므로, 마크업이 있는 안내 문구는
 * 여기 .tsx 컴포넌트로 분리하고 훅에서는 컴포넌트만 참조한다.
 */

interface Props {
  /** 현재 이용 기간 종료일 (KST 포맷 문자열). 없으면 날짜 없는 문구로 폴백 */
  periodEnd: string | null;
}

export const CancelConfirmBody: React.FC<Props> = ({ periodEnd }) => (
  <>
    멤버십을 해지하시겠습니까?
    <br />
    {periodEnd ? (
      <>
        <strong>{periodEnd}</strong>까지는 그대로 이용할 수 있습니다.
      </>
    ) : (
      "현재 이용 기간 만료일까지는 그대로 이용할 수 있습니다."
    )}
    <br />그 전이라면 '다시 구독'으로 언제든 해지를 취소할 수 있습니다.
  </>
);

export const ResumeConfirmBody: React.FC<Props> = ({ periodEnd }) => (
  <>
    {periodEnd ? (
      <>
        종료 예정일(<strong>{periodEnd}</strong>)을 기준으로, 기존에 등록된
        결제수단으로 멤버십을 재개합니다.
      </>
    ) : (
      "종료 예정일을 기준으로, 기존에 등록된 결제수단으로 멤버십을 재개합니다."
    )}
    <br />
    종료일 이후부터 정기결제가 다시 시작됩니다.
  </>
);
